import * as React from "react";
import styled from "styled-components";
import ContentSection from "../../components/about/content-section";
import ImageSection from "../../components/about/image-sectioin";
import { useEffect } from "react";
import AOS from "aos";

const HighExam = () => {
  useEffect(() => {
    // Initialize AOS with settings to only animate once
    AOS.init({
      once: true, // This is the key setting - animations will only happen once
      mirror: false, // Don't mirror animations when scrolling back up
      duration: 800,
      offset: 100, // Controls when the animation triggers
      easing: "ease-out"
    });

    // Refresh AOS on component mount
    AOS.refresh();
  }, []);

  return (
    <StudySection>
      <div data-aos="fade-in" data-aos-duration="600" data-aos-delay="100">
        <ContentSection
          imageSrc={"/assets/home/high-exam-book.png"}
          imageAlt={"High Quality Exam Text"}
          title={"High-Quality Exam Content"}
          description={
            "Practice with original questions that match the style and content of your exam, complete with detailed explanations and references to key textbooks."
          }
        />
      </div>
      <div data-aos="fade-in" data-aos-duration="600">
        <ImageSection
          imageSrc={"/assets/home/high-exam.png"}
          imageAlt={"High Quality Exam Interface"}
        />
      </div>
    </StudySection>
  );
};

const StudySection = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 32px 96px;
  max-width: 1456px;
  margin: 0 auto;
  width: 100%;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    padding: 32px 16px;
    text-align: center;
  }
`;

export default HighExam;
